module.exports = __webpack_public_path__ + "static/media/javascript.e73667c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/filetype/javascript.png
// module id = 2560
// module chunks = 0